<template>
  <!-- 底部 -->
  <div class="allcontain">
    <div class="bottom">
      <p>沈阳星游网络技术有限公司 版权所有 </p>
      <div @click="openNewWindow" style="margin-top: 20px;">辽ICP备2023009521号</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bottom',
  props: {
  },
  methods: {
    openNewWindow() {
      window.open('https://beian.miit.gov.cn/', '_blank');
    }
  }
}
</script>

<style scoped lang="less">
.allcontain {
  width: 100%;
  height: 100px;
  background-color: #f7f8fa;

  .bottom {
    width: 1900px;
    height: 100px;
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;
    text-align: center;

    p {
      padding-top: 20px;
    }
  }

}
</style>